import { render, staticRenderFns } from "./facture-pharmacie.html?vue&type=template&id=3ae0a740&scoped=true&external"
import script from "./facture-pharmacie.js?vue&type=script&lang=js&external"
export * from "./facture-pharmacie.js?vue&type=script&lang=js&external"
import style0 from "./facture-pharmacie.scss?vue&type=style&index=0&id=3ae0a740&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae0a740",
  null
  
)

export default component.exports